(() => {
  if (window.__ows26FreeShippingFlashLoaded) return;
  window.__ows26FreeShippingFlashLoaded = true;

  const START = Date.parse('2026-10-13T22:30:00Z');
  const END = Date.parse('2026-10-14T02:30:00Z');

  function previewAllowed() {
    const params = new URLSearchParams(window.location.search);
    const explicit = params.get('ows26_preview') === 'active';
    const exactDraft = Boolean(window.Shopify && window.Shopify.theme && window.Shopify.theme.id === 188581052509 && window.Shopify.theme.role !== 'live');
    const draftTheme = params.get('preview_theme_id') === '188581052509' || exactDraft || Boolean(window.Shopify && window.Shopify.designMode);
    return explicit && draftTheme;
  }

  function syncUpcart(visible, hours, minutes) {
    if (typeof document.querySelector !== 'function') return;
    const shadow = document.querySelector('#upCart')?.shadowRoot;
    if (!shadow) return;

    let message = shadow.querySelector('#ows26-fs-upcart');
    if (!visible) {
      if (message) message.remove();
      return;
    }

    if (!message) {
      message = document.createElement('div');
      message.id = 'ows26-fs-upcart';
      message.setAttribute('role', 'status');
      message.style.cssText = 'background:#ffd11c;color:#000;border-bottom:1px solid #000;padding:14px 20px;text-align:center;font-family:Arial,sans-serif;font-weight:800;line-height:1.3;letter-spacing:.04em;';
      const headline = document.createElement('div');
      headline.style.cssText = 'font-size:13px;text-transform:uppercase';
      headline.textContent = 'Free shipping · USA + Canada';
      const detail = document.createElement('div');
      detail.style.cssText = 'margin-top:4px;font-size:12px';
      detail.append('Ends 10:30 PM ET · ');
      const hourNode = document.createElement('span');
      hourNode.setAttribute('data-ows26-upcart-hours', '');
      const minuteNode = document.createElement('span');
      minuteNode.setAttribute('data-ows26-upcart-minutes', '');
      detail.append(hourNode, ' HRS : ', minuteNode, ' MIN');
      message.append(headline, detail);
      const body = shadow.querySelector('.upcart-cart-body');
      const announcement = shadow.querySelector('.upcart-public-announcement');
      if (body) body.insertBefore(message, announcement ? announcement.nextSibling : body.firstChild);
    }

    message.querySelector('[data-ows26-upcart-hours]').textContent = String(hours).padStart(2, '0');
    message.querySelector('[data-ows26-upcart-minutes]').textContent = String(minutes).padStart(2, '0');
  }

  function update() {
    const now = Date.now();
    const preview = previewAllowed();
    const live = now >= START && now < END;
    const visible = live || preview;
    const remaining = Math.max(0, preview && !live ? END - START : END - now);
    const totalMinutes = Math.ceil(remaining / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    document.querySelectorAll('[data-ows26-fs]').forEach((root) => {
      root.hidden = !visible;
      root.classList.toggle('is-live', visible);
      root.querySelectorAll('[data-ows26-hours]').forEach((node) => {
        node.textContent = String(hours).padStart(2, '0');
      });
      root.querySelectorAll('[data-ows26-minutes]').forEach((node) => {
        node.textContent = String(minutes).padStart(2, '0');
      });
    });

    document.querySelectorAll('[id$="__ows_hero_aE9hqf"], [id$="__ows_hero"], #shopify-section-ows_hero_aE9hqf, #shopify-section-ows_hero').forEach((baseline) => {
      baseline.hidden = visible;
    });

    syncUpcart(visible, hours, minutes);
  }

  function scheduleCartUpdate() {
    [100, 400, 1000].forEach((delay) => window.setTimeout(update, delay));
  }

  window.ows26FreeShippingUpdate = update;
  update();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    window.setTimeout(update, 0);
  }
  window.setInterval(update, 15000);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('cart:updated', scheduleCartUpdate);
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('button, a');
    const label = `${trigger?.getAttribute('aria-label') || ''} ${trigger?.textContent || ''}`;
    if (/\bcart\b/i.test(label)) scheduleCartUpdate();
  }, true);
})();
